import React from "react";

function getRiskClassName(riskLevel = "") {
  if (/very high|extreme/i.test(riskLevel)) return "danger-info-risk danger-info-risk--extreme";
  if (/high/i.test(riskLevel)) return "danger-info-risk danger-info-risk--high";
  if (/medium/i.test(riskLevel)) return "danger-info-risk danger-info-risk--medium";
  return "danger-info-risk danger-info-risk--low";
}

export default function DangerInfoDetailSections({ data, t }) {
  return (
    <>
      {/* ----------------------------- */}
      {/* 2) Wildlife Risks — SHOW ONLY IF NOT EMPTY */}
      {/* ----------------------------- */}
      {data.wildlife.length > 0 && (
        <section style={{ marginTop: 12 }}>
          <h4>🦈 {t("danger_wildlife")}</h4>

          <ul style={{ paddingLeft: 20 }}>
            {data.wildlife.map((w, i) => (
              <li key={i}>
                <b>{w.species}</b> — {w.notes || w.hazardType || "—"}
                {w.riskLevel && (
                  <span className={getRiskClassName(w.riskLevel)}>
                    [{w.riskLevel}]
                  </span>
                )}
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* -------------------------------- */}
      {/* 3) Environmental Hazards — SHOW ONLY IF NOT EMPTY */}
      {/* -------------------------------- */}
      {data.env.length > 0 && (
        <section style={{ marginTop: 12 }}>
          <h4>🌋 {t("danger_environment")}</h4>

          <ul style={{ paddingLeft: 20 }}>
            {data.env.map((h, i) => (
              <li key={i}>
                <b>{h.type}</b> — {h.notes || "—"}{" "}
                {h.season && <span>({h.season})</span>}
                {h.riskLevel && (
                  <span className={getRiskClassName(h.riskLevel)}>
                    [{h.riskLevel}]
                  </span>
                )}
              </li>
            ))}
          </ul>
        </section>
      )}
    </>
  );
}
